import Vue from 'vue'
import Axios from 'axios'

var WebsiteCreateModuleShopConfig = window.WebsiteCreateModuleShopConfig || {}

/*
 * Default parameters which are added to each request
 */
let axiosParams = {}

// If we are in development mode, we add the xDebug Header to each request
if (process.env.NODE_ENV === 'development') {
  axiosParams = {
    XDEBUG_SESSION_START: 'PHPSTORM'
  }
}

var axios = Axios.create({
  baseURL: WebsiteCreateModuleShopConfig.apiEndpoint,
  timeout: 40000,
  params: axiosParams,
  headers: {
    Authorization: 'Bearer ' + WebsiteCreateModuleShopConfig.auth.clientSecret
  }
})

axios.interceptors.response.use(function (response) {
  return response
}, function (error) {
  return Promise.reject(error)
})

// ----------------------------------------
// Vue Plugin
// ----------------------------------------
const VueAxios = {
  install: function (Vue) {
    // Globally register as $http
    Vue.prototype.$http = axios
  }
}

// ----------------------------------------
// Install vue plugin
// ----------------------------------------
Vue.use(VueAxios)

/**
 * With all the defaults for axios set, we can export it as a module.
 */
export default axios

/*
 * Create a local instance where the baseURL points to the backend
 */
export const localAxios = Axios.create({
  baseURL: WebsiteCreateModuleShopConfig.baseURL,
  timeout: 20000
})



// WEBPACK FOOTER //
// ./client/plugins/axios.js